import { CustomerEntityType } from 'types/customers'
import { BusinessCustomerFormData } from './types'

export const CustomerTypeOptions = [
  { value: CustomerEntityType.COMPANY, label: 'customers.business' },
  { value: CustomerEntityType.INDIVIDUAL, label: 'customers.individual', disabled: true },
]

export const BusinessCustomerDefaultValues: BusinessCustomerFormData = {
  businessName: '',
  businessDescription: '',
  countryOfIncorporation: '',
}
